import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";
import { TemplateData } from "../index";

export const addPsychTitleSlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "TITLE_MASTER_PSYCH" });

  slide.addText("Psychometric Report", { placeholder: "title" });

  if (data.candidateName) {
    slide.addText(data.candidateName, { placeholder: "candidate-name" });
  }

  if (data.createdBy) {
    slide.addText(`Prepared by ${data.createdBy}`, {
      placeholder: "created-by",
    });
  }

  slide.addText(dayjs().format("MMMM YYYY"), { placeholder: "date" });
};
